import React from 'react';
import { Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black/50 border-t border-white/10 pt-16 pb-8 px-4 sm:px-6 lg:px-8 mt-20" data-id="element-97">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-98">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8" data-id="element-99">
          <div className="w-2 h-2 rounded-full bg-brand-violet" data-id="element-100" />
          <span className="text-sm font-bold tracking-wide text-white uppercase" data-id="element-101">
            AURA BIT™
          </span>
        </div>

        <p className="text-xl font-bold text-white mb-4 max-w-2xl" data-id="element-102">
          El sistema de IA aplicada a negocios N°1 para emprendedores y PyMEs de
          Argentina.
        </p>
        <p className="text-gray-400 mb-12 max-w-xl" data-id="element-103">
          Porque hacer crecer tu negocio no debería costarte todos los domingos
          del año.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 mb-16" data-id="element-104">
          <a href="mailto:soportebibliotecad@gmail.com" className="flex items-center justify-center gap-2 text-gray-300 hover:text-white transition-colors bg-white/5 px-6 py-3 rounded-xl border border-white/10" data-id="element-105">
            <Mail className="w-5 h-5 text-brand-violet" data-id="element-106" />
            soportebibliotecad@gmail.com
          </a>
          <a href="https://WWW.BLIBLIOTECADIGITAL.COM" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 text-gray-300 hover:text-white transition-colors bg-white/5 px-6 py-3 rounded-xl border border-white/10" data-id="element-107">
            <Globe className="w-5 h-5 text-brand-violet" data-id="element-108" />
            WWW.BLIBLIOTECADIGITAL.COM
          </a>
        </div>

        <div className="w-full border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-109">
          <p data-id="element-110">
            © AURA BIT™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción sin autorización expresa.
          </p>
          <p className="flex items-center gap-2 font-medium text-gray-400" data-id="element-111">
            🤖 "El próximo lunes puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}